import { SkyLayer } from "./Skyline";

export const Band = () => (
  <section className="band" aria-label="Our belief" data-testid="quote-band">
    <SkyLayer kind="mid" speed="0.18" rel />
    <SkyLayer kind="near" speed="0.35" rel />
    <div className="wrap">
      <blockquote>
        Everyone deserves to be treated with dignity, to feel seen and valued, and to know they{" "}
        <em>do not have to face life's challenges alone.</em>
      </blockquote>
      <cite>Youth. Families. Community. Future.</cite>
    </div>
  </section>
);
